import React, { Component } from 'react';
import { Modal, InputNumber, message, Button, Table, Popconfirm, Popover } from 'antd';
import moment from 'moment';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';

class EditManHour extends Component {
    state = {
        visible: false,
    }

    show = (manHourId, duration, remarks) => {
        this.setState({
            duration,
            manHourId,
            visible: true,
            remarks,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleOk = () => {
        const { duration, manHourId, remarks } = this.state;
        const options = {
            method: 'POST',
            url: `${API_URL.manhour.editmanhour}`,
            data: {
                duration,
                manHourId,
                remarks,
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.data.success);
                    this.setState({ visible: false });
                    this.props.loadData();
                } else {
                    message.error(res.error);
                }
            })
        }
        $.sendRequest(options)
    }

    handleChange = (value) => {
        this.setState({ duration: value });
    }

    render () {
        const { visible, duration } = this.state;
        return (
            <Modal
                title="修改工时"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
            >
                <div className="modal-content">
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{width: '40%'}}>工时数：</div>
                            <div className="item-right" style={{width: '60%'}}>
                                <InputNumber min={0} max={24} value={duration} onChange={this.handleChange} step={0.01} style={{width:70}}/>&nbsp;h
                            </div>
                        </li>
                    </ul>
                </div> 
            </Modal>
        )
    }
}

class MyHourDetail extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
    }

    loadData = () => {
        this.setState({ loading: true });
        const { pagination, searchParam } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.manhour.queryManHourDetail,
            data: {
                offset: pagination.current,
                limit: pagination.pageSize,
                ...searchParam,
            },
            dataType: 'json',
            doneResult: data => {
                pagination.total = data.totalCount;
                this.setState({
                    data: data.datas,
                    loading: false,
                    pagination,
                });
            }
        }
        $.sendRequest(options)
    }

    canEditByInvStatus = (investigationId, callback) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const canEdit = !(data || []).some(i => {
                    if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                        message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                        return true;
                    } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                        message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                        return true;
                    } else if (i.operation === 'TERMINATED_BEFORE_CONTRACT') {
                        message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                        return true;
                    }
                    return false;
                });
                this.setState({ loading: false }, () => {
                    if (canEdit) {
                        callback();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    show = record => {
        this.setState({
            data: [],
            pagination: {
                pageSize: 5,
                current: 1,
            },
            row: record,
            searchParam: {
                hourId: record.hourId,
                hourType: record.hourType,
            },
            detail: {
                Time: `${record.yearNum}-${record.monthNum}`,
                Recorder: `${sessionStorage.userName}( ${sessionStorage.curEmployeeCode} )`,
                clinicalProject: record.investigationName,
                investigationCode: record.investigationCode,
                center: `${record.investigationSiteName}( ${record.investigationSiteCode} )`,
                role: record.roleCode,
            },
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getColumns = () => [{
        title: '工作日期',
        dataIndex: 'manHourDate',
        key: 'manHourDate',
        width: 90,
        render: (text, record) => {
            return (
                <span>
                   {moment(record.manHourDate).format('YYYY-MM-DD')}
                </span>
            );
        },
    }, {
        title: '工作类型',
        dataIndex: 'enterpriseWorkNameValue',
        key: 'enterpriseWorkNameValue',
        width: 90,
    }, {
        title: '工作内容（编号）',
        dataIndex: 'enterpriseWorkTypeName',
        key: 'enterpriseWorkTypeName',
        width: 160,
    }, {
        title: '用时(h)',
        dataIndex: 'totalShow',
        key: 'totalShow',
        width: 80,
        render: (text, record) => {
            const obj = { children: text };
            if (record.manHourVisitTip) {
                const list = record.manHourVisitTip.split(';');
                const node = list.map(item => <div>{item}</div>);
                obj.children = <Popover placement="bottomRight" overlayClassName="gray-pop" content={node}>
                                    <div>
                                        <i className='pop'></i>
                                        {text}
                                    </div>
                                </Popover>
            }
            return obj;
        },
    }, {
        title: '操作',
        key: 'operation',
        width: 85,
        render: (text, record) => {
            const { row = {} } = this.state;
            const { manHourId, durationStringNoH, investigationId } = record;
            return (
                <span>
                    {                                
                        (row.statusName == '待确认(待修改)' || row.statusName == '待确认(已修改)' || row.statusName == '待确认') ? 
                            <span>
                                {
                                    investigationId ? 
                                        <a onClick={() => this.canEditByInvStatus(investigationId, () => this.editManHour(manHourId, durationStringNoH))}>修改</a> 
                                        : 
                                        <a onClick={() => this.editManHour(manHourId, durationStringNoH)}>修改</a>
                                }
                                <span className="ant-divider" />
                                <Popconfirm title='确定删除该工时记录？' onConfirm={() => this.canEditByInvStatus(investigationId, () => this.delManHour(manHourId))} okText="确定" cancelText="取消">
                                    <a >删除</a>
                                </Popconfirm>
                            </span>
                        :
                            <span>
                                <a disabled={true}>修改</a>
                                <span className="ant-divider" />
                                <a disabled={true}>删除</a>
                            </span>
                    }
                </span>
            );
        },
    }]
    
    getDataSource = () => {
        const dataSource = [];
        const { data, pagination } = this.state;
        data.map((item, index) => {
            dataSource.push({
                index: (pagination.current - 1) * 10 + index + 1,
                ...item,
                durationStringNoH: !item.totalShow ? item.totalShow.toFixed(2) : item.totalShow,
            });
        });
        return dataSource;
    }

    editManHour = (manHourId, duration) => {
        this.EditManHourRef.show(manHourId, duration);
    }

    delManHour = (manHourId) => {
        const options = {
            method: 'POST',
            url: `${API_URL.manhour.delmanhour}`,
            data: { manHourId },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.data.success);
                    this.loadData();
                } else {
                    message.error(res.error);
                }
            })
        }
        $.sendRequest(options)
    }

    handleTableChange = (pagination) => {
        const pager = { ...this.state.pagination };
        if (pager.current == pagination.current){
            pager.current = 1;
        } else {
            pager.current = pagination.current;
        }
        this.setState({
            pagination: pager,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { visible, loading, pagination, detail = {} } = this.state;
        const { Time, Recorder, clinicalProject, investigationCode, center, role } = detail;
        return (
            <Modal
                width={600}
                title="明细记录"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div className="modal-content">
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{width: '100%', paddingRight: 0}}>
                                <p style={{whiteSpace: 'normal', textAlign: 'left'}}>
                                    时间 : {Time} | 录入者 ：{Recorder} | 临床项目 ：{clinicalProject}
                                    ( {investigationCode} ) | 中心 ：{center} | 角色 : {role}
                                </p>
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{width: '100%', paddingRight: 0}}>
                                <Table  
                                    columns={this.getColumns()}
                                    dataSource={this.getDataSource()}
                                    rowKey={record => record.index}
                                    loading={loading}
                                    onChange={this.handleTableChange}
                                    scroll={{ x: 505 }}
                                    pagination={pagination}
                                />
                            </div>
                        </li>
                    </ul>
                    <EditManHour ref={ el => this.EditManHourRef = el } loadData={this.loadData} />
                </div>
            </Modal>
        );
    }
}

export { EditManHour, MyHourDetail };


// WEBPACK FOOTER //
// ./src/components/manHour/hour/Widget.js